import styled, { css } from 'styled-components';

// Import components
import { Paragraph, Button } from 'components/elements';

// Import styles utilities
import { rejectGradientButton, flex, customMinResponsive, size } from 'components/styles';

export const ButtonsWrapper = styled.div`
	${flex({
		jc: ({ isOperator }) => (isOperator ? 'center' : 'space-between'),
		fd: 'column'
	})}
	margin-top: 4rem;

	${customMinResponsive(
		size.xsmall,
		css`
			${flex({ jc: 'space-around' })}
		`
	)}
`;

export const ButtonStyled = styled(Button)`
	${flex({ ai: 'center' })}
	width: 22rem;
	height: 4.5rem;
	font-size: 1.4rem;
	line-height: 1.2;
	font-weight: ${({ theme }) => theme.font.medium};
	margin-bottom: 2rem;

	${({ remove }) => remove && rejectGradientButton}

	${customMinResponsive(
		size.xsmall,
		css`
			height: 6rem;
			font-size: 1.6rem;
			margin-bottom: 0;
		`
	)}
`;

export const ButtonText = styled.span`
	${flex()};
	direction: ltr;
	width: max-content;
	color: ${({ theme }) => theme.semiWhite};
`;

export const Description = styled(Paragraph.Ellipsis)`
	color: ${({ theme }) => theme.grayMediumDarkTheme};
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: 1.4rem !important;
	letter-spacing: 0.05rem;
	line-height: 1.5;
	text-align: center;
	white-space: initial;

	span {
		color: ${({ theme }) => theme.white};
		font-weight: ${({ theme }) => theme.font.semiBold};
	}

	${customMinResponsive(
		size.xsmall,
		css`
			font-size: 1.6rem !important;
		`
	)}
`;
